import { formatCurrency } from "@sa-nu/shared-utils/price";

export type ConfirmedPriceSummaryMessages = {
  totalLabel: string;
};

const JA_MESSAGES: ConfirmedPriceSummaryMessages = {
  totalLabel: "合計（税込・大人2名の場合）",
};

/**
 * CTA ボタン直上の独立行。deriveConfirmedPrice の算出結果（確定金額）が
 * 非 null の場合のみ表示する。
 */
export function ConfirmedPriceSummary({
  totalPrice,
  messages = JA_MESSAGES,
}: {
  /** deriveConfirmedPrice の算出結果。null（確定金額利用不可 or CO 未確定）時は非表示 */
  totalPrice: number | null;
  messages?: ConfirmedPriceSummaryMessages;
}) {
  if (totalPrice === null) return null;

  return (
    <div className="flex shrink-0 items-baseline justify-center gap-[4px] px-[16px] pt-[12px]">
      <span className="font-notojp text-dx-text-sub text-[12px] leading-[18px] font-normal">
        {messages.totalLabel}
      </span>
      {/* 価格は Latin/数字のみ。プロジェクトの数字慣例に従い font-roboto。 */}
      <span className="font-roboto text-dx-text-default text-[24px] leading-[28px] font-normal">
        {formatCurrency(totalPrice)}
      </span>
    </div>
  );
}
